var map = {
	"./Layer 2.png": 4798,
	"./TechieMitra.png": 2908,
	"./Weather-forecast.png": 6933,
	"./github.webp": 1856,
	"./insta.jpg": 6174,
	"./linkedin.png": 1661,
	"./menuicon.png": 7561,
	"./mypic (2).jpg": 694,
	"./social-connektt.png": 9607,
	"./web1.png": 1532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;